export default{
    serverIp: process.env.NODE_ENV === "production" ? 'https://mapi.shemen365.com' : 'https://mapi.shemen365.com',
    clientIp: process.env.NODE_ENV === "production" ? 'https://mapi.shemen365.com' : 'https://mapi.shemen365.com',
    node_env: process.env.NODE_ENV
}